/* eslint-disable react-hooks/exhaustive-deps */
import { Chip, Tooltip } from "@mui/material";
import { useState, useEffect } from "react";
import { useInView } from "react-intersection-observer";

export default function PreviewMarker({ viewed, TooltipValue, ...rest }) {
  const markerEl = useInView();
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const handleEntersView = () => {
    setTooltipOpen(true);
    setTimeout(() => {
      setTooltipOpen(false);
    }, 4000);
  };
  const handleLeavesView = () => {
    setTooltipOpen(false);
  };
  useEffect(() => {
    if (markerEl.inView && !!TooltipValue && !viewed) {
      handleEntersView();
    } else {
      handleLeavesView();
    }
  }, [markerEl.inView]);
  return (
    <Tooltip open={tooltipOpen} title={TooltipValue}>
      <Chip
        {...rest}
        ref={markerEl.ref}
        sx={{
          opacity: "0.25",
          ...rest.sx,
        }}
        size="small"
        label={viewed ? "Concluído" : "Não concluído"}
        color={viewed ? "success" : "error"}
      ></Chip>
    </Tooltip>
  );
}
